import { useState } from "react";
import BreadCrumb from "../components/breadCrumb";
import { TextBox } from "../components/common/TextBox";
import PageContent from "../components/pageContent";
import { serviceAuthentication } from "../services/AuthenticationService";
import { useHistory } from "react-router-dom";
import { userLoginAction } from "../redux/actions";
import { useDispatch } from "react-redux";
import logo from "../assets/Telurmix2.png";
import LanguageSelector from "../components/LanguageSelector";
import { useTranslation } from "react-i18next";
import Spinner from "../components/common/Spinner";

// styles
require("./LoginPage.css");

interface Props {
  contextLevel: string;
}

const LoginPage = (props: Props) => {
  const { t }: { t: any } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [authenticationData, setAuthenticationData] = useState({
    username: "",
    password: "",
  });
  const [authenticationStatus, setAuthenticationStatus] = useState({
    message: "",
  });

  let doLogin = (event) => {
    setLoading(true);
    event.preventDefault();

    if (
      authenticationData.username === "" ||
      authenticationData.password === ""
    ) {
      setAuthenticationStatus({
        message: t('Login.EmptyDetailsMsg'),
      });
      setLoading(false);
      return;
    }

    serviceAuthentication.login(authenticationData).then(
      (user: any) => {
        if (user.data.incorrectCredentials) {
          setAuthenticationStatus({
            message: t('Login.LoginFailedMsg'),
          });
        } else {
          serviceAuthentication.loginResult().then(() => {
            localStorage.setItem("currentUser", JSON.stringify(user.data));
            serviceAuthentication.currentUserSubject.next(user.data);
            setAuthenticationStatus({ message: "" });

            const returnUrl = new URLSearchParams(window.location.search).get("returnUrl");
            window.location.assign(returnUrl ? decodeURIComponent(returnUrl) : "/");


            dispatch(userLoginAction(JSON.stringify(user.data)));
            setLoading(false);
          });
        }
      },
      (error) => {
        setAuthenticationStatus({
          message: t('Login.LoginExceptionMsg'),
        });
        setLoading(false);
      }
    );
  };

  return (
    <>
      <div
        style={{ color: "black", maxWidth: "350px" }}
        className="loginPageContainer container z-depth-1 my-5 px-0"
      >
        {loading && <Spinner loadingText={"Loading ..."} />}
        <div className="logoHeader" style={{ width: '100%', backgroundColor: '#fff', marginBottom: '2px', borderRadius: '5px' }}>
          <img src={logo} />
        </div>
        <div className="card">
          <div className="card-header">
            <i className="fas fa-unlock" style={{ marginRight: "10px" }}></i>
            <span>{t('Login.Header')}</span>
            <LanguageSelector />
          </div>
          <div
            className="card-body"
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                doLogin(event);
              }
            }}
          >
            <form onSubmit={(event) => {
              doLogin(event);
            }}>
              <input
                onChange={(event) => {
                  authenticationData.username = event.target.value;
                  setAuthenticationData(authenticationData);
                }}
                type="login"
                id="username"
                className="form-control mb-4 username"
                placeholder={t('Login.Username')}
              />
              <input
                onChange={(event) => {
                  authenticationData.password = event.target.value;
                  setAuthenticationData(authenticationData);
                }}
                type="password"
                id="password"
                className="form-control mb-4 password"
                placeholder={t('Login.Password')}
              />

              {authenticationStatus.message !== "" && (
                <span style={{ color: "red" }}>
                  {authenticationStatus.message}
                </span>
              )}

              <input
                style={{ margin: "auto", display: "block" }}
                className="btn btn-info btn-block my-4"
                type="submit"
                value={t('Login.Button')}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
